import { arrayIncludes } from '@nzyme/utils/array/arrayIncludes.js';
import * as z from 'zod/mini';
export const LanguageArray = ['en', 'pl'];
export const Language = z.enum(LanguageArray);
export const SupportedLanguages = LanguageArray;
/**
 * Coerces an arbitrary string to a supported {@link Language}, falling back to the default
 * language when missing or unrecognized.
 * @util
 * @__NO_SIDE_EFFECTS__
 */
export function getSupportedLanguage(language) {
    return language && arrayIncludes(Language.options, language) ? language : LanguageArray[0];
}
//# sourceMappingURL=Language.js.map